import { render, staticRenderFns } from "./GlobalWebSocket.vue?vue&type=template&id=5313833c"
import script from "./GlobalWebSocket.vue?vue&type=script&lang=js"
export * from "./GlobalWebSocket.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5313833c')) {
      api.createRecord('5313833c', component.options)
    } else {
      api.reload('5313833c', component.options)
    }
    module.hot.accept("./GlobalWebSocket.vue?vue&type=template&id=5313833c", function () {
      api.rerender('5313833c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/WebSocket/GlobalWebSocket.vue"
export default component.exports